import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Cattura `beforeinstallprompt` il prima possibile: Chrome lo emette una sola
// volta al caricamento iniziale (tipicamente sulla pagina di login), molto
// prima che PWAInstallBanner — montato dentro EliosLayout, quindi solo dopo
// l'autenticazione — possa registrare il proprio listener. Senza questo stash
// l'evento andrebbe perso e il popup di installazione non comparirebbe mai.
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__pwaInstallPrompt = e;
  window.dispatchEvent(new CustomEvent("pwa:install-available"));
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// In local development we force-unregister service workers to avoid stale
// cached bundles from old builds (common when extracting a project subset).
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    if (process.env.NODE_ENV !== "production") {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
      });
      return;
    }

    navigator.serviceWorker.register("/sw.js").then((registration) => {
      if (registration.waiting) {
        window.dispatchEvent(new CustomEvent("pwa:update-available", { detail: registration }));
      }

      registration.addEventListener("updatefound", () => {
        const newSW = registration.installing;
        if (!newSW) return;
        newSW.addEventListener("statechange", () => {
          if (newSW.state === "installed" && navigator.serviceWorker.controller) {
            window.dispatchEvent(new CustomEvent("pwa:update-available", { detail: registration }));
          }
        });
      });

      setInterval(() => {
        registration.update().catch(() => {});
      }, 30 * 60 * 1000);
    }).catch(() => {});

    let reloading = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });
  });
}
